"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require("react-intl");

var _reactHtmlParser = require("react-html-parser");

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _GradientCollapse = require("../GradientCollapse");

var _GradientCollapse2 = _interopRequireDefault(_GradientCollapse);

require("./global.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/**
 * Product Description Component.
 * Render the description and technical specifications of a product
 */


var ProductDescription = /*#__PURE__*/function (_Component) {
  _inherits(ProductDescription, _Component);

  function ProductDescription() {
    _classCallCheck(this, ProductDescription);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductDescription).apply(this, arguments));
  }

  _createClass(ProductDescription, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          specifications = _this$props.specifications,
          description = _this$props.description;

      if (!description && !specifications) {
        return null;
      }

      var specificationItems = specifications.map(function (specification) {
        return {
          property: specification.name,
          specifications: specification.values[0]
        };
      });
      return _react2["default"].createElement("div", {
        className: "vtex-product-description flex-l"
      }, _react2["default"].createElement("div", {
        className: "w-100 w-60-l"
      }, description && _react2["default"].createElement(_react2["default"].Fragment, null, _react2["default"].createElement("div", {
        className: "lh-solid b c-on-base mb5"
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "product-description.title"
      })), _react2["default"].createElement("div", {
        className: "c-muted-1"
      }, _react2["default"].createElement(_GradientCollapse2["default"], {
        collapseHeight: 220
      }, (0, _reactHtmlParser2["default"])(description))))), specifications && specifications.length > 0 && _react2["default"].createElement("div", {
        className: "vtex-product-specifications mt6 mt0-l w-100 w-40-l pl8-l"
      }, _react2["default"].createElement("div", {
        className: "vtex-product-specifications__title lh-solid b c-on-base mb5"
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "technicalspecifications.title"
      })), _react2["default"].createElement(_GradientCollapse2["default"], {
        collapseHeight: 220
      }, _react2["default"].createElement("table", {
        className: "vtex-product-specifications__table w-100 bg-base border-collapse"
      }, _react2["default"].createElement("thead", null, _react2["default"].createElement("tr", null, _react2["default"].createElement("th", {
        className: "w-50 b--muted-4 bb bt c-muted-2 t-body tl pa5"
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "product-description.property"
      })), _react2["default"].createElement("th", {
        className: "w-50 b--muted-4 bb bt c-muted-2 t-body tl pa5"
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "product-description.specification"
      })))), _react2["default"].createElement("tbody", null, specificationItems.map(function (specification, i) {
        return _react2["default"].createElement("tr", {
          key: i
        }, _react2["default"].createElement("td", {
          className: "w-50 b--muted-4 bb pa5"
        }, specification.property), _react2["default"].createElement("td", {
          className: "w-50 b--muted-4 bb pa5"
        }, specification.specifications));
      }))))));
    }
  }]);

  return ProductDescription;
}(_react.Component);

ProductDescription.defaultProps = {
  specifications: []
};
ProductDescription.propTypes = {
  /** Product description string */
  description: _propTypes2["default"].string,

  /** Intl object to provides internationalization */
  intl: _propTypes2["default"].any.isRequired,

  /** Specifications that will be displayed on the table */
  specifications: _propTypes2["default"].arrayOf(_propTypes2["default"].shape({
    /** Specification name */
    name: _propTypes2["default"].string.isRequired,

    /** Specifications value */
    values: _propTypes2["default"].arrayOf(_propTypes2["default"].string).isRequired
  }))
};
exports["default"] = (0, _reactIntl.injectIntl)(ProductDescription);